import { Input } from "@/components/ui/input";
import { normalizePaperDimension } from "@/lib/paper-format.helper";

/**
 * Ô khổ giấy 2 số có sẵn dấu × (FB-6H7GKA, 03/11/2026): người dùng chỉ nhập rộng và dài, không gõ dấu nhân.
 * Giá trị lưu giữ nguyên dạng cũ "710x450" để báo giá, lệnh sản xuất, bản in đọc như trước;
 * rời ô thì chuẩn hoá bằng normalizePaperDimension (gõ cm như 71 × 45 tự đổi sang mm).
 */
function splitSize(value: string | null | undefined): [string, string] {
  const raw = String(value ?? "").trim();
  if (!raw) return ["", ""];
  const parts = raw.split(/\s*[xX*×]\s*/);
  if (parts.length >= 2) return [parts[0].replace(/[^\d.]/g, ""), parts[1].replace(/[^\d.]/g, "")];
  const nums = raw.match(/\d+(?:\.\d+)?/g) || [];
  return [nums[0] ?? "", nums[1] ?? ""];
}

export function PaperSizeInput({
  value,
  onChange,
  placeholderW = "Rộng",
  placeholderH = "Dài",
  testId,
  className = "",
}: {
  value: string | null | undefined;
  onChange: (next: string) => void;
  placeholderW?: string;
  placeholderH?: string;
  testId?: string;
  className?: string;
}) {
  const [w, h] = splitSize(value);
  const emit = (nextW: string, nextH: string) => {
    const a = nextW.replace(/[^\d.]/g, "");
    const b = nextH.replace(/[^\d.]/g, "");
    onChange(a || b ? `${a}x${b}` : "");
  };
  const normalizeOnBlur = () => {
    if (!w || !h) return;
    const norm = normalizePaperDimension(`${w}x${h}`);
    if (norm && norm !== value) onChange(norm);
  };
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid={testId}>
      <Input
        inputMode="decimal"
        className="h-9 text-sm text-right"
        placeholder={placeholderW}
        value={w}
        onChange={(e) => emit(e.target.value, h)}
        onBlur={normalizeOnBlur}
        data-testid={testId ? `${testId}-w` : undefined}
        aria-label="Rộng (mm)"
      />
      <span className="shrink-0 text-sm font-semibold text-slate-500" aria-hidden>
        ×
      </span>
      <Input
        inputMode="decimal"
        className="h-9 text-sm text-right"
        placeholder={placeholderH}
        value={h}
        onChange={(e) => emit(w, e.target.value)}
        onBlur={normalizeOnBlur}
        data-testid={testId ? `${testId}-h` : undefined}
        aria-label="Dài (mm)"
      />
    </div>
  );
}
